/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentUsageSummaryDto } from './DeploymentUsageSummaryDto';
import {
    DeploymentUsageSummaryDtoFromJSON,
    DeploymentUsageSummaryDtoFromJSONTyped,
    DeploymentUsageSummaryDtoToJSON,
} from './DeploymentUsageSummaryDto';

/**
 * 
 * @export
 * @interface DeploymentUsageSummariesDto
 */
export interface DeploymentUsageSummariesDto {
    /**
     * The usage summary per dat.
     * @type {Array<DeploymentUsageSummaryDto>}
     * @memberof DeploymentUsageSummariesDto
     */
    summaries: Array<DeploymentUsageSummaryDto>;
}

/**
 * Check if a given object implements the DeploymentUsageSummariesDto interface.
 */
export function instanceOfDeploymentUsageSummariesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "summaries" in value;

    return isInstance;
}

export function DeploymentUsageSummariesDtoFromJSON(json: any): DeploymentUsageSummariesDto {
    return DeploymentUsageSummariesDtoFromJSONTyped(json, false);
}

export function DeploymentUsageSummariesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentUsageSummariesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summaries': ((json['summaries'] as Array<any>).map(DeploymentUsageSummaryDtoFromJSON)),
    };
}

export function DeploymentUsageSummariesDtoToJSON(value?: DeploymentUsageSummariesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summaries': ((value.summaries as Array<any>).map(DeploymentUsageSummaryDtoToJSON)),
    };
}

